module.exports = __webpack_public_path__ + "media/common/fonts/streamline-large/streamline-large-6a516ac87a96f0a62f27d51497b0a6d0.woff";